import routerView from '@/views/layout/routerView'

export const talkManageRoute = [
  {
    path: 'talkManage',
    name: '商机管理',
    icon: 'icon-xiansuo2',
    icon_img: 'nav04',
    component: routerView,
    hidden: false,
    children: [
      {
        path: 'unlockList',
        component: () => import('@/views/clue/page/unlockList'),
        name: '解锁列表',
        hidden: true,
        icon: 'icon-yangshi_icon_tongyong_unlock',
        meta: {
          nextStart: true,
          breadcrumb: ['商机管理', '解锁列表']
        }
      },
      {
        path: 'enterprise',
        component: () => import('@/views/clue/page/enterprise'),
        name: '企业画像',
        hidden: true,
        hide: true,
        meta: {
          title: '企业画像',
          icon: 'ileftIcon1',
          breadcrumb: ['商机线索', '企业画像']
        }
      },
      {
        path: 'myAttention',
        component: () => import('@/views/clue/page/myAttention'),
        name: '我的收藏',
        hidden: true,
        icon: 'icon-shoucang',
        meta: {
          nextStart: true,
          breadcrumb: ['商机管理', '我的收藏']
        }
      }
    ]
  }
]
export default talkManageRoute
